var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRuler = function SvgIconRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.073 14.508a1.75 1.75 0 0 0 0 2.475l4.94 4.94a1.75 1.75 0 0 0 2.474 0L21.924 9.485a1.75 1.75 0 0 0 0-2.475l-4.94-4.94a1.75 1.75 0 0 0-2.475 0zM8.25 20.33l-4.586-4.586 1.959-1.958 2.295 2.295a1 1 0 0 0 1.414-1.414l-2.295-2.295 1.96-1.961 2.296 2.295a1 1 0 0 0 1.414-1.414l-2.295-2.295 1.96-1.961 2.296 2.295a1 1 0 1 0 1.414-1.414l-2.295-2.295 1.96-1.96 4.586 4.585z",
    clipRule: "evenodd"
  })));
};
export default SvgIconRuler;